export default IconPrescription => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-prescription" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 19v-16h4.5a4.5 4.5 0 1 1 0 9h-4.5" />
  <path d="M19 21l-9 -9" />
  <path d="M13 21l6 -6" />
</svg>`;